import React from 'react';
import { FuelTypography } from '@frete.com/fuel-react';
import { DetailPropsInterface } from './DetailTypes';
import * as Styled from './DetailStyles';

function Detail({ title, description }: DetailPropsInterface) {
  return (
    <Styled.DetailContainer>
      <FuelTypography
        tag="h4"
        size="caption"
        weight="bold"
        color="neutral-default"
      >
        {title}
      </FuelTypography>
      <FuelTypography size="body-sm" weight="bold">
        <Styled.WrapperTextOverflowEllipsis>
          {description}
        </Styled.WrapperTextOverflowEllipsis>
      </FuelTypography>
    </Styled.DetailContainer>
  );
}

export default Detail;
